/**
 * Log levels in ascending order of severity
 */
export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  CRITICAL = 4,
}

/**
 * Context object that can be attached to log entries
 */
export type LogContext = Record<string, unknown>

/**
 * Standard log entry structure
 */
export interface LogEntry {
  level: LogLevel
  message: string
  timestamp: string
  context?: LogContext
  error?: Error
  environment?: string
  userId?: string
  userAgent?: string
}

/**
 * Transport interface - defines how logs are sent to a destination
 */
export interface LogTransport {
  log(entry: LogEntry): void
  shouldLog(level: LogLevel): boolean
}

/**
 * Logger configuration options
 */
export interface LoggerConfig {
  minLevel: LogLevel
  transports: LogTransport[]
  enableConsole?: boolean
  enableAppInsights?: boolean
  environment?: string
}

/**
 * Main logger interface
 */
export interface Logger {
  debug(message: string, context?: LogContext): void
  info(message: string, context?: LogContext): void
  warn(message: string, context?: LogContext): void
  error(message: string, error?: Error, context?: LogContext): void
  critical(message: string, error?: Error, context?: LogContext): void
}
